import { SettingsCache } from "../cache/SettingsCache";
import { getSession } from "../helper";
import { LIST_LIFE_DOMAINS } from "../life_domain/routes";
import { LIST_ELEMENTS_FOR_DROPDOWNS } from "../routes/queries";

export function getSomedayMaybeFormFields(): any {
  return [
    {
      type: "text",
      required: true,
      key: "name",
      label: "Name",
      placeholder: "Someday/Maybe Element Name",
    },
    {
      type: "query_dropdown",
      required: false,
      key: "lifeDomainId",
      label: "Life Domain",
      noSelectionLabel: "No Life Domain",
      apiCall: {
        documentNode: LIST_LIFE_DOMAINS,
        key: "listLifeDomains",
      },
      apiVariables: {
        session: getSession(),
      },
    },
    {
      type: "query_dropdown",
      required: false,
      key: "parentElementId",
      label: "Parent Element",
      noSelectionLabel: "No Parent Element",
      apiCall: LIST_ELEMENTS_FOR_DROPDOWNS,
      apiVariables: {
        session: getSession(),
        types: [3],
      },
    },
    {
      type: "hardcoded",
      key: "priority",
      value: SettingsCache.getInstance().getDefaultPriority(),
    },
    {
      type: "hardcoded",
      key: "type",
      value: 3,
    },
  ];
}
